import CopyToClipboard from '../CopyToClipboard';
import styles from './Copy.module.scss';
import type { Props } from './Copy.types';

const Copy = ({ type, text, className }: Props) => {
  const icon = type === 'tel' ? <PhoneIcon /> : <MailIcon />;
  const hrefType = type === 'tel' ? 'tel' : 'mailto';

  return (
    <div className={`${styles['Copy']}${className ? ` ${className}` : ''}`}>
      <div className={styles.icon}>{icon}</div>
      <a href={`${hrefType}:${text}`}>{text}</a>
      <CopyToClipboard copy={text} />
    </div>
  );
};

export default Copy;

const PhoneIcon = () => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width={21}
    height={20}
    viewBox='0 0 21 20'
    fill='#376578'
  >
    <path
      opacity={0.5}
      d='M10.543 1.668c1.4 0 2.509 0 3.377.119.893.122 1.616.38 2.186.96.57.58.824 1.315.944 2.224.116.883.116 2.012.116 3.436v3.188c0 1.425 0 2.553-.116 3.437-.12.908-.373 1.644-.944 2.224-.57.58-1.293.838-2.186.96-.868.119-1.977.119-3.377.119h-.086c-1.4 0-2.51 0-3.378-.12-.893-.121-1.616-.379-2.186-.959-.57-.58-.823-1.316-.943-2.224-.117-.884-.117-2.012-.117-3.437V8.407c0-1.424 0-2.553.117-3.436.12-.909.373-1.644.943-2.225.57-.58 1.293-.837 2.186-.96.868-.118 1.977-.118 3.378-.118h.086Z'
    />
    <path d='M7.643 15.425c0-.32.255-.581.571-.581h4.571c.316 0 .572.26.572.581a.577.577 0 0 1-.572.581H8.214a.576.576 0 0 1-.571-.58Z' />
  </svg>
);

const MailIcon = () => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width={21}
    height={20}
    viewBox='0 0 21 20'
    fill='#376578'
  >
    <path
      opacity={0.5}
      d='M12.333 2.5H8.666c-3.457 0-5.185 0-6.26 1.098C1.334 4.697 1.334 6.464 1.334 10s0 5.303 1.074 6.402C3.481 17.5 5.209 17.5 8.667 17.5h3.666c3.457 0 5.185 0 6.26-1.098 1.073-1.099 1.073-2.867 1.073-6.402 0-3.536 0-5.303-1.074-6.402C17.52 2.5 15.79 2.5 12.333 2.5Z'
    />
    <path d='M16.44 6.694a.688.688 0 0 0-.88-1.056l-1.98 1.649c-.854.713-1.448 1.206-1.95 1.528-.485.312-.814.417-1.13.417-.316 0-.645-.105-1.13-.417C8.867 8.493 8.273 8 7.42 7.287l-1.98-1.65a.687.687 0 0 0-.88 1.057l2.013 1.678c.813.677 1.471 1.226 2.053 1.6.605.39 1.195.635 1.874.635.68 0 1.269-.246 1.874-.635.582-.374 1.24-.923 2.053-1.6l2.013-1.678Z' />
  </svg>
);
